
import { IHash } from "@/shared";
import { baContainer } from "../../ioc";
import { ITimeZoneHelperService } from "./ITimeZoneHelperService";
import { ConvertDateTimePeriod } from "./models/ConvertDateTimePeriod";
import { ConvertDateTimesRequest } from "./models/ConvertDateTimesRequest";
import { ConvertedDateTimeItem } from "./models/ConvertedDateTimeItem";

export class TimeZoneHelperService implements ITimeZoneHelperService {
    ConvertDateTimes(request: ConvertDateTimesRequest): Promise<IHash<ConvertedDateTimeItem>> {
        throw new Error("Method not implemented.");
    }
    ConvertToOrganizerTimeZone(datetime: Date): Promise<Date> {
        throw new Error("Method not implemented.");
    }
    ConvertPeriodToOrganizerTimeZone(period: ConvertDateTimePeriod): Promise<ConvertDateTimePeriod> {
        throw new Error("Method not implemented.");
    }
    // private readonly _utilityRepository: IUltilitiesRepository;
    // private readonly _appSettingService: IApplicationSettingsService;
    // constructor() {
    //     this._utilityRepository = baContainer.resolve(TokenIUltilitiesRepository);
    //     this._appSettingService = baContainer.resolve(TokenIApplicationSettingsService);
    // }
    // async ConvertDateTimes(request: ConvertDateTimesRequest): Promise<IHash<ConvertedDateTimeItem>> {
    //     const convertedDateTimes: IHash<ConvertedDateTimeItem> = {};
    //     const convertRequest: RepoConvertDateTimesRequest = {
    //         Ticks: request.DateTimeTicksToConvert,
    //         ClientTimeZone: request.ClientTimeZone,
    //         SourceTimeZone: request.OriginalTimeZone,
    //         TargetTimeZone: request.TargetTimeZone
    //     }
    //     const repoResponses = await this._utilityRepository.ConvertDateTimes(convertRequest);
    //     if (repoResponses && repoResponses.length > 0) {
    //         repoResponses.forEach(response => {
    //             const originalDateTime = convertNetTicksUTCToDateTime(response.OriginalTicks);
    //             const convertedDateTime = convertNetTicksUTCToDateTime(response.ConvertedTicks);
    //             convertedDateTimes[response.OriginalTicks] = {
    //                 OriginalDateTime: originalDateTime,
    //                 ConvertedDateTime: convertedDateTime
    //             }
    //         });
    //     }
    //     return convertedDateTimes;
    // }
    // async ConvertToOrganizerTimeZone(datetime: Date): Promise<Date> {
    //     const clientTimeZone = this._appSettingService.ClientTimeZoneStandardName;
    //     const dateTimeTicks = convertToNetTicks(datetime);
    //     const convertRequest: ConvertDateTimesRequest = {
    //         DateTimeTicksToConvert: [dateTimeTicks],
    //         OriginalTimeZone: clientTimeZone,
    //         TargetTimeZone: this._appSettingService.OrganizerTimeZoneStandardName,
    //         ClientTimeZone: this._appSettingService.ClientTimeZoneStandardName
    //     }
    //     const repoResponses = await this.ConvertDateTimes(convertRequest);
    //     if (repoResponses && repoResponses[dateTimeTicks]) {
    //         return repoResponses[dateTimeTicks].ConvertedDateTime;
    //     }
    //     return datetime;
    // }
    // async ConvertPeriodToOrganizerTimeZone(period: ConvertDateTimePeriod): Promise<ConvertDateTimePeriod> {
    //     const clientTimeZone = this._appSettingService.ClientTimeZoneStandardName;
    //     const startTicks = convertToNetTicks(period.Start);
    //     const endTicks = convertToNetTicks(period.End);
    //     const convertRequest: ConvertDateTimesRequest = {
    //         DateTimeTicksToConvert: [startTicks, endTicks],
    //         OriginalTimeZone: clientTimeZone,
    //         TargetTimeZone: this._appSettingService.OrganizerTimeZoneStandardName,
    //         ClientTimeZone: this._appSettingService.ClientTimeZoneStandardName
    //     }
    //     const repoResponses = await this.ConvertDateTimes(convertRequest);
    //     if (repoResponses && repoResponses[startTicks] && repoResponses[endTicks]) {
    //         const convertedStart = repoResponses[startTicks].ConvertedDateTime;
    //         const convertedEnd = repoResponses[endTicks].ConvertedDateTime;
    //         return {
    //             Start: convertedStart,
    //             End: convertedEnd
    //         };
    //     }
    //     return period;
    // }
}